import { features } from '@/mocks/data';

export default function FeaturesSection() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900 mb-3">
            为什么选择 <strong className="text-primary-500">91n.com</strong>
          </h2>
          <p className="text-foreground-600 text-sm max-w-xl mx-auto">
            六大核心优势，为您打造极致的使用体验
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {features.map((feature, idx) => (
            <div
              key={idx}
              className="group p-6 rounded-lg bg-background-100/70 border border-background-200/50 hover:border-primary-200/50 transition-all duration-300"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-md bg-primary-100 text-primary-600 mb-4 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors duration-300">
                <i className={`${feature.icon} text-xl`} />
              </div>
              <h3 className="text-base font-semibold text-foreground-900 mb-2">{feature.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}